<template>
  <div
    class="fixed right-0 top-0 w-[calc(100%-2rem)] md:w-2/3 max-w-2xl min-w-[16rem] pointer-events-none z-50 flex flex-col items-stretch gap-3 pr-4 pt-4"
    role="alert"
  >
    <!-- Success Flash Message -->
    <s-toast v-if="flash?.success" type="success" @dismiss="flash.dismiss('success')">
      {{ flash.success }}
    </s-toast>

    <!-- Error Flash Message -->
    <s-toast v-if="flash?.error" type="error" @dismiss="flash.dismiss('error')">
      {{ flash.error }}
    </s-toast>

    <!-- Warnings Flash Message -->
    <s-toast v-if="flash?.warnings?.length" type="warning" @dismiss="flash.dismiss('warnings')">
      <ul class="flex flex-col flex-1">
        <li v-for="warning in flash.warnings" :key="warning">{{ warning }}</li>
      </ul>
    </s-toast>
  </div>
</template>
<script setup lang="ts">
import {useFlash} from '../composables/useFlash';
import SToast from './SToast.vue';

const flash = useFlash();
</script>
